import { getSupabase } from '@potencial/supabase';
import { getAuthUser } from '../lib/authState';
import { deleteRow, insertRow } from '../lib/db';

export interface SystemLog {
  id?: string;
  timestamp: string;
  operation: string;
  input?: string;
  errorMessage: string;
  errorStack?: string;
  userId?: string;
}

export const logSystemError = async (
  operation: string,
  error: any,
  input?: string
) => {
  try {
    const user = getAuthUser();
    if (!user) return; // Only log if authenticated

    const logData: SystemLog = {
      timestamp: new Date().toISOString(),
      operation,
      errorMessage: error instanceof Error ? error.message : String(error),
      errorStack: error instanceof Error ? error.stack : undefined,
      input: input ? (input.length > 10000 ? input.substring(0, 10000) + '...[TRUNCATED]' : input) : undefined,
      userId: user.uid,
    };

    // Remove undefined fields
    const cleanLogData = Object.fromEntries(
      Object.entries(logData).filter(([_, v]) => v !== undefined)
    );

    await insertRow('system_logs', cleanLogData);
  } catch (e) {
    console.error("Failed to save system log:", e);
  }
};

export const getSystemLogs = async (maxLogs: number = 100): Promise<SystemLog[]> => {
  try {
    const { data, error } = await getSupabase()
      .from('system_logs')
      .select('*')
      .order('timestamp', { ascending: false })
      .limit(maxLogs);
    if (error) throw error;
    return (data ?? []) as SystemLog[];
  } catch (error) {
    console.error("Failed to fetch system logs:", error);
    throw error;
  }
};

export const deleteSystemLog = async (logId: string) => {
  try {
    await deleteRow('system_logs', logId);
  } catch (error) {
    console.error("Failed to delete system log:", error);
    throw error;
  }
};

export const deleteAllSystemLogs = async (logs: SystemLog[]) => {
  try {
    const promises = logs.map(log => log.id ? deleteRow('system_logs', log.id) : Promise.resolve());
    await Promise.all(promises);
  } catch (error) {
    console.error("Failed to delete all system logs:", error);
    throw error;
  }
};
